var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNote3 = function SvgNote3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.058 2.083v9.975A2.6 2.6 0 0 0 4.1 14.141l4.342 3.25c.925.692 2.2.692 3.125 0l4.341-3.25a2.6 2.6 0 0 0 1.042-2.083V2.083z",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.333 2.708H1.667a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h16.666a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625M13.333 7.292H6.667a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h6.666a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625M13.333 11.458H6.667a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h6.666a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625"
  })));
};
export default SvgNote3;